// extracted by mini-css-extract-plugin
export default {"StaticPage":"StaticPage_StaticPage__444Ty"};